import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import {
  Alert,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

const ModalStartReturn = ({ isOpen, sale, isSubmitting, error, onCancel, onSubmit }) => {
  const [awb, setAwb] = useState('');
  const [localError, setLocalError] = useState(null);
  const saleId = sale ? sale.id : null;

  useEffect(() => {
    if (!isOpen) return;
    setAwb('');
    setLocalError(null);
  }, [isOpen, saleId]);

  const dismiss = isSubmitting ? undefined : onCancel;
  const invoice = sale && sale.invoice_number ? sale.invoice_number : 'this sale';
  const shownError = localError || error;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting || !sale) return;
    if (awb.trim() === '') {
      setLocalError('The airway bill is required.');
      return;
    }
    setLocalError(null);
    onSubmit(awb.trim());
  };

  return (
    <Modal isOpen={isOpen} toggle={dismiss} className="modal-dialog modal-md">
      <ModalHeader toggle={dismiss}>Start Return</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <p>
            Enter the airway bill the buyer used to send <strong>{invoice}</strong> back.
            The sale then shows on All Returns and Outstanding Returns.
          </p>
          <FormGroup className="mb-0">
            <Label for="formStartReturnAwb">Buyer airway bill</Label>
            <Input
              id="formStartReturnAwb"
              value={awb}
              disabled={isSubmitting}
              onChange={(event) => setAwb(event.target.value)}
            />
          </FormGroup>
          {shownError && (
            <Alert color="danger" className="mt-3 mb-0">
              {shownError}
            </Alert>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={isSubmitting || !sale}>
            {isSubmitting ? 'Starting...' : 'Start Return'}
          </Button>{' '}
          <Button color="secondary" type="button" disabled={isSubmitting} onClick={onCancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

ModalStartReturn.propTypes = {
  isOpen: propTypes.bool,
  sale: propTypes.object,
  isSubmitting: propTypes.bool,
  error: propTypes.string,
  onCancel: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
};

ModalStartReturn.defaultProps = {
  isOpen: false,
  sale: null,
  isSubmitting: false,
  error: null,
};

export default ModalStartReturn;
